// extracted by mini-css-extract-plugin
module.exports = {"notice":"VatNotice_notice__QRdnc"};